import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';

interface TutorialContextType {
	tourActive: boolean;
	setTourActive: Dispatch<SetStateAction<boolean>>;
}

interface TutorialProviderProps {
	children: ReactNode;
}

const TutorialContext = createContext<TutorialContextType | undefined>(undefined);

export const TutorialProvider: React.FC<TutorialProviderProps> = ({ children }) => {
	const [tourActive, setTourActive] = useState<boolean>(() => {
		const stored = localStorage.getItem('tourActive');
		return stored !== null ? JSON.parse(stored) : true; // default to true
	});

	useEffect(() => {
		localStorage.setItem('tourActive', JSON.stringify(tourActive));
	}, [tourActive]);

	return <TutorialContext.Provider value={{ tourActive, setTourActive }}>{children}</TutorialContext.Provider>;
};

export const useTutorial = (): TutorialContextType => {
	const context = useContext(TutorialContext);
	if (context === undefined) {
		throw new Error('useTutorial must be used within a TutorialProvider');
	}
	return context;
};
